// Mitlaufende Kaufbox der Produktseite (sections/main-product.liquid, .wt-product__main), Desktop ab 900 px.
// Das Mitlaufen macht reines CSS (position: sticky, assets/su-layout.css), ohne Scroll-Handler.
// Dieses Skript misst nur die Hoehe der Box, wenn sie sich aendert (Akkordeon, Set-Block, Bilder geladen),
// und schreibt sie nach --su-box-h. Daraus rechnet das CSS, ob die Box ins Fenster passt (oben stehen)
// oder hoeher ist (mitlaufen, bis ihr Ende sichtbar ist, dort stehen bleiben).
//
// Galerie-Slider (ab 1200 px, Runde 19): Die Sektion ist nur so hoch wie die Kaufbox. Ist ihr Ende im Fenster, schiebt es
// das links verankerte Bild hoch. Waechst die Box dann (Akkordeon oder Set-Block auf), wird die Sektion laenger und das
// Bild kaeme zurueck nach unten. Deshalb wird genau in diesem Fall einmalig um die Hoehenaenderung gescrollt, bevor
// gezeichnet wird: Bild und naechste Sektion bleiben auf dem Bildschirm, wo sie waren. Beim Scrollen selbst laeuft kein JS.
(() => {
  const mqSlider = window.matchMedia('(min-width: 1200px)');
  const start = () => document.querySelectorAll('.product-section .wt-product__main').forEach((main) => {
    if (main.dataset.suSticky) return;
    main.dataset.suSticky = '1';
    const box = main.parentElement;
    let lastH = main.offsetHeight;
    const set = () => {
      const h = main.offsetHeight;
      main.style.setProperty('--su-box-h', h + 'px');
      const d = h - lastH;
      lastH = h;
      if (!d || !mqSlider.matches || document.documentElement.dataset.suGallery !== 'slider') return;
      const vh = window.innerHeight;
      const pushBefore = vh - (box.getBoundingClientRect().bottom - d); // so weit war das Bild vor der Aenderung hochgeschoben
      let delta = 0;
      if (pushBefore > 0) delta = d;                         // war geschoben: Abstand zum Sektionsende beibehalten
      else if (d < 0 && pushBefore - d > 0) delta = d + pushBefore; // wird erst durch das Schrumpfen geschoben: genau das ausgleichen
      delta = Math.max(delta, -window.scrollY);
      if (delta) window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(main);
    else window.addEventListener('resize', set);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
